import { useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import { AccessGate } from '../../../generic';
import Header from '../../../shared/settings/SettingsPageHeader';
import SettingsPageTableActions from '../../../shared/settings/SettingsPageTableActions';
import { useCanCreateOIDCProvider } from '../../shared/permissions';

import ModalCreateOIDCProvider from './ModalCreateOIDCProvider';
import OIDCProvidersTable from './OIDCProvidersTable';

import styles from './OIDCProviders.module.less';

const OIDCProviderSettings: VoidFunctionComponent = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const canCreateOIDCProvider = useCanCreateOIDCProvider();

  return (
    <>
      <Header heading="OIDC Providers">
        <Header.Paragraph>
          OIDC providers configured for your organization. These providers enable
          federated authentication and service account trust relationships.
        </Header.Paragraph>
      </Header>

      <AccessGate behavior="showPage">
        <div className={styles.tableContainer}>
          <SettingsPageTableActions>
            <SettingsPageTableActions.TooltipButton
              id="add-oidc-provider-button"
              type="secondary"
              size="large"
              showTooltip={!canCreateOIDCProvider}
              tooltip="You are not permitted to add an OIDC provider."
              onClick={() => setIsCreateModalOpen(true)}
              isDisabled={!canCreateOIDCProvider}
            >
              Add an OIDC provider
            </SettingsPageTableActions.TooltipButton>
            <SettingsPageTableActions.SearchInput
              value={searchValue}
              onChange={setSearchValue}
              placeholder="Search by issuer"
              label="search-by-issuer"
            />
          </SettingsPageTableActions>

          <OIDCProvidersTable searchValue={searchValue} />
        </div>

        <ModalCreateOIDCProvider
          isOpen={isCreateModalOpen}
          onHide={() => setIsCreateModalOpen(false)}
        />
      </AccessGate>
    </>
  );
};

export default OIDCProviderSettings;
